import { MonitorBase } from './_MonitorBase';

export class MonitorTextures extends MonitorBase {
  constructor(game, parent, config) {
    super(game, parent, { label: 'textures', ...config });

    this.game.textures.on(Phaser.Textures.Events.ADD, this.updateMonitor, this);
    this.game.textures.on(Phaser.Textures.Events.REMOVE, this.updateMonitor, this);
    this.updateMonitor();
  }

  shutdown() {
    this.game.textures.off(Phaser.Textures.Events.ADD, this.updateMonitor, this);
    this.game.textures.off(Phaser.Textures.Events.REMOVE, this.updateMonitor, this);
  }

  updateMonitor() {
    this._textureAudit = {};
    this._textureAudit.totalPixels = 0;
    this._textureAudit.totalRam = 0;
    this._textureAudit.textures = [];

    const textureKeys = this.game.textures.getTextureKeys();
    textureKeys.forEach((key) => {
      const texture = this.game.textures.get(key);
      texture.source.forEach((source) => {
        const pixels = source.width * source.height;
        const ram = (source.width * source.height * 4) / (1024 * 1024);
        this._textureAudit.totalPixels += pixels;
        this._textureAudit.totalRam += ram;
        this._textureAudit.textures.push({
          key: key,
          size: `${source.width}x${source.height}`,
          pixels,
          ram,
        });
      });
    });

    this._textureAudit.textures.sort((a, b) => b.pixels - a.pixels);

    let textureString = '';
    if (this._textureAudit.totalPixels > 1000000)
      textureString += `Pixels : ${(this._textureAudit.totalPixels / 1000000).toFixed(2)} m`;
    else textureString += `Pixels : ${Math.round(this._textureAudit.totalPixels)}`;
    textureString += `, est. RAM : ${Math.round(this._textureAudit.totalRam)} mb`;

    this.setValue(textureString);
  }

  getLog() {
    let str = '';
    str += `\nTotal Textures\t\t: ${this._textureAudit.textures.length}`;
    str += `\nTotal Pixels\t\t: ${Math.round(this._textureAudit.totalPixels).toLocaleString()}`;
    str += `\nTotal est. Ram\t\t: ${Math.round(this._textureAudit.totalRam)} mb`;
    str += `\nTextures in Cache\t\t:`;

    this._textureAudit.textures.forEach((texture) => {
      str += `\n\t${texture.key}`;
      str += `\n\t\tpixels : ${texture.pixels.toLocaleString()}`;
      str += `\n\t\tram : ${texture.ram.toFixed(2)} mb`;
    });
    return str;
  }
}
